import * as Sentry from '@sentry/nextjs';

export default function reportError(context) {
    if (context?.error instanceof Error) {
        context.error.name = 'ApplicationErrorReport: ' + context?.error?.name;
    }

    Sentry.captureException(context.error, {
        level: 'critical',
    });

    if (process.env.NEXT_PUBLIC_ENVIRONMENT === 'Development') {
        console.error(context);
    }
}
